import { render, staticRenderFns } from "./BusKnowledgeFileModal__Style#Drawer.vue?vue&type=template&id=1b1329b2&scoped=true&"
import script from "./BusKnowledgeFileModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BusKnowledgeFileModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BusKnowledgeFileModal__Style#Drawer.vue?vue&type=style&index=0&id=1b1329b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1329b2",
  null
  
)

export default component.exports